module.exports = __webpack_public_path__ + "assets/img/carousel-4-320.6ae9d1ef.webp";